import { render, staticRenderFns } from "./IconWithText.vue?vue&type=template&id=ed20c42c&scoped=true&"
import script from "./IconWithText.vue?vue&type=script&lang=js&"
export * from "./IconWithText.vue?vue&type=script&lang=js&"
import style0 from "./IconWithText.vue?vue&type=style&index=0&id=ed20c42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20c42c",
  null
  
)

export default component.exports